/**
 * momentIA logo — inline SVG.
 * <Logo />        → icon + wordmark
 * <LogoIcon />    → just the gradient square with the "m"
 */

export function LogoIcon({ size = 32, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      aria-label="momentIA"
    >
      <defs>
        <linearGradient id="momentia-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8b5cf6" />
          <stop offset="55%" stopColor="#c026d3" />
          <stop offset="100%" stopColor="#ec4899" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="64" height="64" rx="14" fill="url(#momentia-grad)" />
      <text
        x="32"
        y="32"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="'Inter', 'Helvetica', sans-serif"
        fontWeight="700"
        fontSize="40"
        fill="#ffffff"
        letterSpacing="-0.02em"
      >
        m
      </text>
    </svg>
  );
}

export default function Logo({ className = '', variant = 'light' }) {
  // variant: 'light' (white "moment" for dark bg) or 'dark' (black "moment" for light bg)
  const momentColor = variant === 'dark' ? '#0a0a0f' : '#ffffff';
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} aria-label="momentIA">
      <LogoIcon size={32} />
      <span className="font-display font-bold text-xl tracking-tight leading-none">
        <span style={{ color: momentColor }}>moment</span>
        <span className="bg-gradient-to-r from-fuchsia-500 to-pink-500 bg-clip-text text-transparent">IA</span>
      </span>
    </div>
  );
}
